import isElectron from 'is-electron';
import { ELanguages, isSupportedLanguage } from '../i18n';

const getBrowserLanguage = (): ELanguages | undefined => {
  const userLanguage = navigator.language;
  const languageKey = userLanguage.split('-')[0];
  if (languageKey === 'sv') {
    return ELanguages.se;
  }
  return isSupportedLanguage(languageKey) ? (languageKey as ELanguages) : undefined;
};

const getDesktopLanguage = async (): Promise<ELanguages | undefined> => {
  try {
    if (!window.electronApi) throw new Error('preload.ts initialization failed.');

    const systemLanguage = await window.electronApi.getSystemLocale();

    if (typeof systemLanguage !== 'string') {
      return undefined;
    }

    const languageKey = systemLanguage.split('-')[0];
    if (languageKey === 'sv') {
      return ELanguages.se;
    }

    return isSupportedLanguage(languageKey) ? (languageKey as ELanguages) : undefined;
  } catch (error) {
    console.error('Error getting desktop language:', error);
    return undefined;
  }
};

export const getSystemLanguage = async (): Promise<ELanguages | undefined> => {
  if (isElectron()) {
    return await getDesktopLanguage();
  }
  return getBrowserLanguage();
};
